import { FC, HTMLAttributes } from 'react'
import { useFileUrl } from 'shared/hooks'
import {
  Container,
  Icon,
  Link,
  RemoveIcon,
  Paragraph,
} from './UploadedFile.style'

const DEFAULT_ID_PREFIX = 'uploaded-file'

interface UploadedFileProps extends Partial<HTMLAttributes<HTMLDivElement>> {
  file: File
  onDelete?: () => void
  loading?: boolean
  onClick?: () => void
}

const UploadedFile: FC<UploadedFileProps> = ({
  file,
  loading,
  onDelete,
  onClick,
  ...props
}) => {
  const url = useFileUrl(file)
  const Component = () =>
    onClick ? (
      <Paragraph onClick={onClick}>{file.name}</Paragraph>
    ) : (
      <Link id={`${ID_PREFIX}-link`} href={url} target="_blank">
        {file.name}
      </Link>
    )

  const ID_PREFIX = props.id
    ? `${props.id}-${DEFAULT_ID_PREFIX}`
    : DEFAULT_ID_PREFIX

  return (
    <Container {...props}>
      <Icon />
      <Component />
      {onDelete && (
        <RemoveIcon
          disabled={loading}
          onClick={onDelete}
          id={`${ID_PREFIX}-close-btn`}
        />
      )}
    </Container>
  )
}

export default UploadedFile
